<div
    class="betslip-over-ask"
    [class.betslip-over-ask--loading]="isPendingState"
    [class.betslip-over-ask--review]="isReviewState"
    [msAutomation]="{ offerId: offerId }">
    <bs-betslip-over-ask-header *ngIf="!inColumn"></bs-betslip-over-ask-header>
    <bs-betslip-over-ask-pending
        class="betslip-over-ask-pending-component"
        *ngIf="isPendingState"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [pickListProps]="pickListProps">
    </bs-betslip-over-ask-pending>
    <bs-betslip-over-ask-review
        class="betslip-over-ask-review-component"
        *ngIf="isReviewState"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [remainingSeconds]="remainingSeconds"
        [pickListProps]="pickListProps"
        [summaryProps]="summaryProps"
        [decisionSource]="decisionSource">
    </bs-betslip-over-ask-review>
</div>
